export const AppLanguage = {
  French: "fr",
  English: "en",
};

export const AppDefaultLanguage = AppLanguage.French;